import { useCallback, useContext } from "react";
import PropTypes from "prop-types";
import { MachineStatusEditManager } from "components/CaseManagement/CaseDetail/MachineStatus/MachineStatusEditManager";
import { SnackbarQueueContext } from "contexts/SnackbarQueueContext";
import { useFetchPatch } from "hooks/fetch/useFetchPatch";

export const MachineStatusEditRow = ({
  loading,
  machineStatus,
  machineStatusTypes,
  onSuccess,
  onCancel
}) => {
  const { addSnackbarToQueue } = useContext(SnackbarQueueContext);

  const {
    patchCallback: patchMachineStatus,
    loading: patchMachineStatusLoading
  } = useFetchPatch(
    `machine_status/${machineStatus.id}`,
    () => {
      addSnackbarToQueue({
        message: "Expected RTS log updated.",
        severity: "success"
      });
      onSuccess();
    },
    () => {
      addSnackbarToQueue({
        message: "Expected RTS log failed to save.",
        severity: "error"
      });
    }
  );

  const handlePatchMachineStatus = useCallback(
    values => {
      patchMachineStatus(values);
    },
    [patchMachineStatus]
  );

  return (
    <MachineStatusEditManager
      testLabel="edit"
      loading={loading || patchMachineStatusLoading}
      minDate={null}
      machineStatus={machineStatus}
      machineStatusTypes={machineStatusTypes}
      onSubmit={handlePatchMachineStatus}
      onCancel={onCancel}
    />
  );
};

MachineStatusEditRow.propTypes = {
  loading: PropTypes.bool,
  machineStatus: PropTypes.object,
  machineStatusTypes: PropTypes.array,
  onSuccess: PropTypes.func,
  onCancel: PropTypes.func
};
